export const styles = {
	header: {
		color: '#000000',
		fontSize: '1rem',
		fontWeight: '400',
		textAlign: 'center',
		lineHeight: '1.5rem',
		whiteSpace: 'pre-line',
	},
};
